export default __webpack_public_path__ + "static/media/warehouse.73ea64c3.jpg";